var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_4375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1529 17.94C16.4435 19.243 14.362 19.9649 12.2129 20C5.21289 20 1.21289 12 1.21289 12C2.45678 9.68189 4.18203 7.65661 6.27289 6.06M10.1129 4.24C10.8012 4.07888 11.506 3.99834 12.2129 4C19.2129 4 23.2129 12 23.2129 12C22.6059 13.1356 21.8819 14.2047 21.0529 15.19M14.3329 14.12C14.0582 14.4147 13.727 14.6512 13.359 14.8151C12.991 14.9791 12.5938 15.0673 12.191 15.0744C11.7882 15.0815 11.3881 15.0074 11.0145 14.8565C10.6409 14.7056 10.3016 14.481 10.0167 14.1962C9.73186 13.9113 9.50728 13.5719 9.3564 13.1984C9.20551 12.8248 9.13142 12.4247 9.13852 12.0219C9.14563 11.6191 9.2338 11.2218 9.39777 10.8538C9.56173 10.4858 9.79814 10.1546 10.0929 9.88M1.21289 1L23.2129 23",
    stroke: "#3F3F3F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_4375"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.212891)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/eye-off.13dd0375bc2c40db9fd22b5c38a58465.svg";
export { ForwardRef as ReactComponent };